/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  queryParams = {
    offset: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let offset = 0;
    if (!isEmpty(params.offset)) {
      let temp = Number(params.offset);
      if (!Number.isNaN(temp) && temp > 0) {
        offset = temp;
      }
    }

    return hash({
      posts: this.store.query('posts/globalnotice', {
        perPage: 20,
        offset,
      }),
      groups: this.store.findAll('schools/group'),
    });
  }
}
